import { useQuery } from '@tanstack/react-query';
import { approvalService } from '../../api/services/approvalService';
import { useSession } from '../../auth/useSession';
import { useHasPermission } from '../../auth/useHasPermission';

/**
 * Pending-approvals count for the tab-bar badge.
 * Only fires when the current session grants MOB-APRV visibility.
 * Included in the ['approvals', ...] key family so the header refresh
 * button (which invalidates `['approvals']`) also refreshes the badge.
 */
export function useApprovalsCount() {
  const { session } = useSession();
  const canSee = useHasPermission('MOB-APRV');
  const propertyId = session?.selectedPropertyId ?? 'dev';

  return useQuery({
    queryKey: ['approvals', 'count', propertyId],
    queryFn: () => approvalService.getPendingCount(),
    enabled: canSee,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
}
